import React from 'react'
import HeadIcon from '../Components/HeadIcon'
import TopImage from '../Static/Images/TopImage.png'
import STopImage from '../Static/Images/STopImage.png'
import CompanyCard from '../Components/CompanyCard'
import sessionImage from '../Static/Images/sessionImage.png'
import arrow from '../Static/Images/arrow.png'

const Top =(props)=>{
  return(
    <>
      <div className='topContainer'>
        <img src={TopImage} alt='' className='TopImage'/>
        <img src={STopImage} alt='' className='STopImage'/>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLScGf7xqMRScYgS6NdOTm7rstHJlGyzPkIqqmiTgXCiygDLIug/viewform" target='_blank' rel="noopener noreferrer" className="form"><button>お申し込みフォーム</button></a>
        
      <div className="mainContainer">
        <HeadIcon title="開催にあたって"/>
        <p className='contents'>学生時代に貸与型奨学金を利用した方が、札幌市が認定する企業等へ就職し、札幌圏内に定住した場合一部奨学金を支援する制度があります！今回は認定企業限定のオンライン合同企業説明会を行います！
                                是非ご参加ください！</p>

        <HeadIcon title="開催日"/>
        <p className='contents'>7/15(水) 10:00～</p>
        <HeadIcon title="対象"/>
        <p className='contents'>
            奨学金返還支援対象者<br/><span>※奨学金を借りていない方も参加できます。</span>     
        </p>

        <HeadIcon title="オンラインイベントのイメージ"/>
        <img src={sessionImage} alt='' className="sessionImage"/>

        <HeadIcon title="参加方法・用意するもの"/>
          <ul className="contents">
            <li>以下のお申し込みフォームよりお申し込みください。</li>
            <li>当日お使いのスマートフォン・パソコンにzoomのインストールをお願いします。(前日までにご登録いただいたメールアドレス宛にzoomリンクをお送りします。)</li>
          </ul>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScGf7xqMRScYgS6NdOTm7rstHJlGyzPkIqqmiTgXCiygDLIug/viewform" target='_blank' rel="noopener noreferrer" className="form"><button>お申し込みフォーム</button></a>
        <HeadIcon title="当日のスケジュール"/>
        <p className="contents">
          各ルームはブレイクアウトルーム機能で区切っています。<br />学生の皆さんは企業間を自由に移動OK!
        </p>
        <table className="tg contents">
          <tbody>
            <tr>
              <th></th>
              <th className="centerTitle0614-1">全体の流れ</th>
              <th className="centerTitle0614-2">ルーム1</th>
              <th className="centerTitle0614-2">ルーム2</th>
              <th className="centerTitle0614-2">ルーム3</th>
              <th className="centerTitle0614-2">ルーム4</th>
              <th className="centerTitle0614-2">ルーム5</th>
              <th className="centerTitle0614-2">ルーム6</th>
              <th className="centerTitle0614-2">ルーム7</th>
              <th className="centerTitle0614-2">ルーム8</th>
            </tr>
            <tr>
              <td className="center time">10:00~10:20</td>
              <td className="center compSession0614-1">準備</td>
              <td className="center compSession0614-2" colSpan="8">
                OPEN・準備(各ルーム・待機室)
              </td>
            </tr>

            <tr>
              <td className="center time">10:20〜10:30</td>
              <td className="center compSession0614-1">全体説明</td>
              <td className="center compSession0614-2" colSpan="8">
                全体説明
              </td>
            </tr>
            <tr>
              <td className="center time">10:30〜11:00</td>
              <td className="center compSession0614-1">第1部第1ターン</td>
              <td className="center compSession0614-2">
                機械開発北旺(土木建築業)
              </td>
              <td className="center compSession0614-2">ネイビーズ・クリエイション(情報処理)</td>
              <td className="center compSession0614-2">
                札幌大蔵学園(こども園,幼稚園)
              </td>
              <td className="center compSession0614-2">さくらコミュニティーサービス・悠ライフ(医療・福祉,教育など))</td>
              <td className="center compSession0614-2">井上技研(建築業)</td>
              <td className="center compSession0614-2">永浜クロス(インテリア資材総合卸売)</td>
              <td className="center compSession0614-2">流研(情報処理サービス)</td>
              <td className="center compSession0614-2">内池建設(建設)</td>
            </tr>
            <tr>
              <td className="center break">15分休憩</td>
              <td className="center arrow" colSpan="9">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">11:15〜11:45</td>
              <td className="center compSession0614-1">第1部第2ターン</td>
              <td className="center compSession0614-2">
                機械開発北旺(土木建築業)
              </td>
              <td className="center compSession0614-2">ネイビーズ・クリエイション(情報処理)</td>
              <td className="center compSession0614-2">
              札幌大蔵学園(こども園,幼稚園)
              </td>
              <td className="center compSession0614-2">さくらコミュニティーサービス・悠ライフ(医療・福祉,教育など)</td>
              <td className="center compSession0614-2">井上技研(建築業)</td>
              <td className="center compSession0614-2">永浜クロス(インテリア資材総合卸売)</td>
              <td className="center compSession0614-2">流研(情報処理サービス)</td>
              <td className="center compSession0614-2">内池建設(建設)</td>
            </tr>
            <tr>
              <td className="center break">お昼休憩</td>
              <td className="center arrow" colSpan="9">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">13:00〜13:30</td>
              <td className="center compSession0614-1">第2部第1ターン</td>
              <td className="center compSession0614-2">
                ソフテック(IT・ソフトウェア)
              </td>
              <td className="center compSession0614-2">
                タカフジ(製造業)
              </td>
              <td className="center compSession0614-2">クレタ(卸売業,小売業)</td>
              <td className="center compSession0614-2">トーホーエンジニアリング(建設業)</td>
              <td className="center compSession0614-2">リズム学園(保育教育)</td>
              <td className="center compSession0614-2">ビックボイス(ソフトウェア開発など)</td>
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
            </tr>   

            <tr>
              <td className="center break">15分休憩</td>
              <td className="center arrow" colSpan="9">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            
            <tr>
              <td className="center time">13:45〜14:15</td>             
              <td className="center compSession0614-1">第2部第2ターン</td>
              <td className="center compSession0614-2">
                ソフテック(IT・ソフトウェア)
              </td>
              <td className="center compSession0614-2">
                タカフジ(製造業)
              </td>
              <td className="center compSession0614-2">クレタ卸売業,小売業)</td>
              <td className="center compSession0614-2">トーホーエンジニアリング(建設業)</td>
              <td className="center compSession0614-2">リズム学園(保育教育)</td>
              <td className="center compSession0614-2">ビックボイス(ソフトウェア開発など)</td>
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
            </tr>   
            
            <tr>
              <td className="center break">15分休憩</td>

              <td className="center arrow" colSpan="9">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            
            <tr>
              <td className="center time">14:30〜15:00</td>
              <td className="center compSession0614-1">第3部第1ターン</td>
              <td className="center compSession0614-2">
                日精機工(機械部品の卸売)
              </td>
              <td className="center compSession0614-2">エル技術コンサルタント(測量,土木設計など)</td>
              <td className="center compSession0614-2">
                石狩友愛福祉会(福祉)
              </td>
              <td className="center compSession0614-2">コクサク(造園建設業)</td>
              <td className="center compSession0614-2">よねざわ工業(製造業,建設業)</td>
              
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
            </tr>
            <tr>
              <td className="center break">15分休憩</td>

              <td className="center arrow" colSpan="9">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">15:15〜15:45</td>
              <td className="center compSession0614-1">第3部第2ターン</td>
              <td className="center compSession0614-2">
                日精機工(機械部品の卸売)
              </td>
              <td className="center compSession0614-2">エル技術コンサルタント(測量,土木設計など)</td>
              <td className="center compSession0614-2">
                石狩友愛福祉会(福祉)
              </td>
              <td className="center compSession0614-2">コクサク(造園建設業)</td>
              <td className="center compSession0614-2">よねざわ工業(製造業,建設業)</td>
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
              <td className="center compSession0614-2"></td>
            </tr>

          </tbody>
        </table>

        <HeadIcon title="出展予定企業"/>
        <div className="companyContainer">
        {props.companies.length ? props.companies.map((item,i)=>(
          <CompanyCard 
            key={i}
            data={item.fields} 
            />
            )): 
          (<p>Now Loading...</p>)}
        </div>
        <HeadIcon title="主催・運営・協力"/>
          <div className="contents">
            <p>主催：札幌市</p>
            <p>運営：北海道新聞社</p>
            <p>協力：<a href="https://13labo.com/" target='_blank' rel="noopener noreferrer">13LABO</a></p>
          </div>
        <HeadIcon title="お問い合わせ"/>
          <p className="contents"><a href="https://13labo.com#contact" target='_blank' rel="noopener noreferrer">13LABOホームページ</a>　よりお問い合わせください。</p>
      </div>
      </div>
    </>
  )
}

export default Top